import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import { isStringOfLength } from "@pheaa/channels-component-library";
import packageJson from "../../../package.json";
import useNavigateQSA from "../../utils/hooks/useNavigateQSA";
import { CLIENT_PHEAA, currentClient } from "../../config/clients";
import {
	HELP_MODULE_CONTEXT,
	HELP_MODULE_DEFAULT,
	HELP_MODULE_KEY,
	currentDate
} from "../../config/common";
import React, { useMemo } from "react";
import { styled, useTheme } from "@mui/material/styles";

const { name, version } = packageJson;

const ResourceLink = styled(Box)(({ theme }) => ({
	color: theme.palette.primary.contrastText
}));

const getFooterConfig = () => ({
	content: {
		copyright: {
			[CLIENT_PHEAA]: (
				<React.Fragment>
					<p>&copy; Pennsylvania Higher Education Assistance Agency, {currentDate.getYear()}. (<ResourceLink component="a" href="http://www.nmlsconsumeraccess.org/" rel="noreferrer" target="_blank">NMLS# 1619466 Consumer Access</ResourceLink>).</p>
					<p>PHEAA conducts its student loan servicing operations commercially as American Education Services.</p>
				</React.Fragment>
			)
		},
		resources: {
			[CLIENT_PHEAA]: [{
				label: "Contact Us",
				link: HELP_MODULE_CONTEXT
			}, {
				label: "About Us",
				link: "https://www.pheaa.org/about/"
			}, {
				label: "Privacy Policy",
				link: "https://www.pheaa.org/about/privacy-policy.shtml"
			}, {
				label: "Office of Consumer Advocacy",
				link: "https://www.pheaa.org/about/contact-us/office-consumer-advocacy.shtml"
			}]
		}
	}
});

const versionStyles = {
	fontSize: "1rem",
	paddingBottom: 1,
	paddingTop: 1,
	textAlign: "center"
};

const Footer = () => {

	const config = useMemo(() => getFooterConfig(), []);
	const navigate = useNavigateQSA();
	const theme = useTheme();

	const handleClickHelp = e => {
		e.preventDefault();
		navigate({ search: { [HELP_MODULE_KEY]: HELP_MODULE_DEFAULT } });
	};

	return (
		<Box
			className="cmp-footer"
			component="footer"
			id="footer"
			mt="auto"
			pt={10}
			py={3}
			sx={{
				backgroundColor: theme.palette.footer.main,
				color: theme.palette.primary.contrastText,
				display: "flex",
				flexDirection: "column"
			}}
		>
			<Box className="cmp-footer__inner" maxWidth="lg" sx={{ margin: "0 auto", width: "100%" }}>
				<Grid container maxWidth="xl" spacing={{ xs: 0, lg: 2 }}>
					<Grid item xs={12} lg={12}>
						<Box px={theme.spacing(2)} py={theme.spacing(2)}>
							<Box
								className="cmp-footer__resource-list"
								component="ul"
								sx={{ display: { xs: "block", lg: "flex" } }}
							>
								{
									config.content.resources[currentClient].map((resource, key) => {
										let isLocal = isStringOfLength(resource.link) && resource.link.startsWith("/");
										let onClick = resource.link === HELP_MODULE_CONTEXT ? handleClickHelp : null;

										return (
											<Box component="li" key={key} py={theme.spacing(0.625)} sx={{ padding: { lg: `0 ${theme.spacing(2)} 0 0` } }}>
												<ResourceLink
													component={isLocal ? Link : "a"}
													href={isLocal ? null : resource.link}
													onClick={onClick}
													rel={isLocal ? null : "noreferrer"}
													target={isLocal ? null : "_blank"}
													to={isLocal ? resource.link : null}
												>
													{resource.label}
												</ResourceLink>
											</Box>
										);
									})
								}
							</Box>
							<Box mt={4} sx={{ lg: { margin: `${theme.spacing(0)} ${theme.spacing(2)}` } }}>
								{config.content.copyright[currentClient]}
							</Box>
						</Box>
					</Grid>
				</Grid>
			</Box>
			<Box className="a11y-hidden" sx={versionStyles}>{`${name}-${version}`}</Box>
		</Box>
	);
};

export default Footer;